export const downloadFile = (url: string) => {
  const urldownload = window.URL.createObjectURL(new Blob([url]));
  const link = document.createElement("a");
  link.href = urldownload;
  link.setAttribute("download", `export.csv`);
  document.body.appendChild(link);
  link.click();
};
